<template>
  <div>
    <b-card class="mb-2" no-body>
      <b-card-header class="d-flex justify-content-between align-items-center p-2">
        {{ $dt('employees.rates.title','Create new user rate record') }}
        <b-button size="sm" type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small />
          {{ $dt('employees.rates.save', 'Set new rate') }}
        </b-button>
      </b-card-header>
      <b-card-body class="p-2">
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary" />
        </div>
          <b-row v-else>
            <b-col md="4">
              <b-form-group label-cols-md="2" :label="$dt('employees.rates_form.internal_rate', 'Rate')" label-align-md="right"
                :invalid-feedback="fErr('internal_rate')" :state="fErrState('internal_rate')" class="mb-0">
                <b-form-input type="number" :class="{ 'is-invalid': fErr('internal_rate') }" v-model="entity.internal_rate" />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label-cols-md="3" :label="$dt('employees.rates_form.starts_at', 'Start date')" label-align-md="right"
                :invalid-feedback="fErr('starts_at')" :state="fErrState('starts_at')" class="mb-0">
                <b-form-datepicker :state="fErrState('starts_at')" locale="lv" start-weekday="1"
                  :placeholder="$dt('employees.rates_form.placeholder.starts_at', 'Start date')" v-model="entity.starts_at" />
              </b-form-group>
            </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-spinner  v-if="spinners.listIsLoading" type="grow" variant="primary" class="mx-auto"/>
    <b-list-group v-else>
      <b-list-group-item v-for="r in rateList" :key="r.id"  class="d-flex justify-content-between align-items-center py-1">
        <span>{{formatDate(r.starts_at)}}</span>
        <span>{{r.internal_rate.toFixed(2)}}</span>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import moment from 'moment';
import Services from '@/services/index';
import VT from '@/store/types';
// import { mapGetters, mapActions } from 'vuex';

export default {
  mounted() {
    this.getData();
    // this.load();
  },
  data() {
    return {
      spinners: {
        listIsLoading: false,
        contentIsLoading: false,
        isSaving: false,
      },
      rateList: [],
      entity: this.value,
      errorMsg: this.errors,
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          starts_at: moment().format('YYYY-MM-DD'),
          internal_rate: null,
        };
      },
    },
  },
  components: {
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
  },
  methods: {
    formatDate(d) {
      return moment(d).format('DD-MM-YYYY');
    },
    getData() {
      this.listIsLoading = true;
      Services.jira.employeeRates({ id: this.id, params: { notpaginate: 1 } }).then(({ data }) => {
        this.rateList = data.data;
        this.listIsLoading = false;
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      Services.jira.employeeRateAdd({ id: this.id, data: { ...this.entity, user_id: this.id } }).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        this.entity = {
          starts_at: moment().format('YYYY-MM-DD'),
          internal_rate: null,
        };
        // merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        this.getData();
      }).catch((data) => {
        this.spinners.isSaving = false;
        this.errorMsg = data.errors || {};
      });
    },
  }
};
</script>

<style scoped>

</style>
